import { useEffect, useState } from 'react';
import { useConfigService } from '@thd-nucleus/experience-context';
import { parseTntEventData } from '../helpers/tnt-variables';

export const useHideFBT = () => {
  const initialHideFBT = useConfigService('fs:hideFBT');
  const [fbtTnTFS, setFbtTnTFS] = useState(null);

  useEffect(() => {
    if (typeof LIFE_CYCLE_EVENT_BUS === 'undefined') {
      return undefined;
    }
    const handleRecsFsTnt = (eventData) => {
      const parsedValues = parseTntEventData(eventData);
      if (Object.keys(parsedValues).length > 0) {
        setFbtTnTFS(parsedValues);
      }
    };
    LIFE_CYCLE_EVENT_BUS.lifeCycle.on('recsFS.tnt', handleRecsFsTnt);
    return () => {
      if (LIFE_CYCLE_EVENT_BUS.lifeCycle?.off) {
        LIFE_CYCLE_EVENT_BUS.lifeCycle.off('recsFS.tnt', handleRecsFsTnt);
      }
    };
  }, []);

  return fbtTnTFS?.hideFBT ?? initialHideFBT;
};
